import React, { useEffect, useMemo, useState } from "react";
import { Form, Input, Button, Select, message, Card, Alert } from "antd";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getJobsApi, updateJobApi, createJobApi } from "../../../apiservice/ats";

const { Option } = Select;

const JobNewOrEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  // Determine if this is edit mode based on URL
  const isEdit = location.pathname.includes("/edit");

    // ✅ Read workflow param
  const workflowName = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get("workflow");
  }, [location.search]);

  useEffect(() => {
    if (isEdit && id) {
      loadJob();
    } else {
      // Reset form for new job
      form.resetFields();
    }
  }, [id, isEdit]);

  const loadJob = async () => {
    try {
      setLoading(true);
      const res = await getJobsApi({ id });
      const job = Array.isArray(res.data) ? res.data[0] : res.data;
      form.setFieldsValue(job);
      setLoading(false);
    } catch (err) {
      console.error(err);
      message.error("Failed to load job");
      setLoading(false);
    }
  };

  const handleSave = async (values) => {
    try {
      if (isEdit && id) {
        await updateJobApi({ ...values, id });
        message.success("Job updated successfully");
      } else {
        await createJobApi(values);
        message.success("Job created successfully");
      }
      navigate("/ats/jobs");
    } catch (err) {
      console.error(err);
      message.error("Failed to save job");
    }
  };

  return (
    <Card
      title={isEdit ? "Edit Job" : "Add Job"}
      style={{ maxWidth: 600, margin: "40px auto" }}
    >
      {/* ✅ Workflow Banner */}
      {workflowName && (
        <Alert
          message="Workflow Triggered Update"
          description={`This record is being updated via workflow: ${workflowName}`}
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <Form form={form} layout="vertical" onFinish={handleSave}>
        <Form.Item label="Job Title" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Client" name="client" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Location" name="location" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Job Type" name="job_type" rules={[{ required: true }]}>
          <Select>
            <Option value="full-time">Full-Time</Option>
            <Option value="part-time">Part-Time</Option>
            <Option value="contract">Contract</Option>
            <Option value="internship">Internship</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Status" name="status" rules={[{ required: true }]}>
          <Select>
            <Option value="active">Open</Option>
            <Option value="disabled">Closed</Option>
          </Select>
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input.TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default JobNewOrEdit;
